import React from 'react';
import MovingCarAnimation from '../MovingCarAnimation';
import BreakdownSegment from './BreakdownSegment';
import MarcaCarousel from './MarcaCarousel';
import PaginationDots from './PaginationDots';
import { SEGMENT_CONFIGS } from './segmentsConfig';

const StatCardCompact = ({
  title,
  value,
  icon: Icon,
  color,
  showCarAnimation,
  showMarcasBreakdown,
  type,
  segmentValues,
  isAlertCard,
  canClick,
  handleClick,
  cardClasses,
  titleClasses,
  valueClasses,
  sortedMarcasEntries,
  totalPages,
  currentPage,
  handlePageChange,
}) => {
  const typeConfig = SEGMENT_CONFIGS.compact[type];
  const hasBreakdown = showMarcasBreakdown && sortedMarcasEntries;

  return (
    <div
      className={cardClasses}
      onClick={canClick ? handleClick : undefined}
      role={canClick ? 'button' : undefined}
      tabIndex={canClick ? 0 : undefined}
      onKeyPress={canClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(); } : undefined}
    >
      <div>
        <p className={titleClasses}>{title}</p>
        <p className={valueClasses}>
          {value}{' '}
          <span className={`text-xs ${isAlertCard ? 'text-white/80' : 'text-gray-400'} font-normal`}>total</span>
        </p>

        {showCarAnimation && (
          <div className="mt-1 mb-1">
            <MovingCarAnimation isMoving={value > 0} size="small" />
          </div>
        )}
      </div>

      {/* Footer */}
      <div>
        <div className="min-w-0">
          {hasBreakdown && (
            <div>
              {typeConfig && typeConfig.segments.map((seg) => (
                <BreakdownSegment
                  key={seg.prop}
                  dotColor={seg.dotColor}
                  label={seg.label}
                  value={segmentValues[seg.prop]}
                  hideIfZero={seg.hideIfZero}
                  accent={seg.accent}
                  isAlertCard={isAlertCard}
                  variant="compact"
                  textSize={typeConfig.textSize}
                />
              ))}

              <MarcaCarousel
                sortedMarcasEntries={sortedMarcasEntries}
                totalPages={totalPages}
                currentPage={currentPage}
                isAlertCard={isAlertCard}
                variant="compact"
              />
            </div>
          )}
        </div>

        {/* Pagination dots */}
        {hasBreakdown && (
          <div>
            <PaginationDots
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              isAlertCard={isAlertCard}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCardCompact;
